import React from "react";

import Modal from "../../Modal/Modal";
import {
  Container,
  H2CompensationTitle,
  PCompensationDetail,
} from "./compensationDetailStyle";

export const CompensationDetailRecaudo = (props) => {
  const { sidebarInfo, toggleModal } = props;
  return (
    <Modal
      onOutsideClick={() => {
        toggleModal();
      }}
    >
      <React.Fragment>
        <Container>
          <h1 style={{ fontWeight: 700 }}>Detalles de compensación</h1>
          <div>
            <div>
              <H2CompensationTitle>USUARIO APROBADOR</H2CompensationTitle>
              <PCompensationDetail paddingRight="1rem">
                {sidebarInfo.compensationDetail.approved_by}
              </PCompensationDetail>
            </div>
            <div>
              <H2CompensationTitle>USUARIO COMPENSADOR</H2CompensationTitle>
              <PCompensationDetail paddingRight="1rem">
                {sidebarInfo.compensationDetail.compensed_by}
              </PCompensationDetail>
            </div>
            <div>
              <H2CompensationTitle>
                CÓDIGO DE COMPENSACIÓN SAP
              </H2CompensationTitle>
              <PCompensationDetail paddingRight="1rem">
                <b>{sidebarInfo.compensationDetail.compensation_code}</b>
              </PCompensationDetail>
            </div>
            <div>
              <H2CompensationTitle>COMENTARIO COMPENSADOR</H2CompensationTitle>
              <PCompensationDetail paddingRight="1rem">
                {sidebarInfo.compensationDetail.compensation_comment}
              </PCompensationDetail>
            </div>
          </div>
        </Container>
      </React.Fragment>
    </Modal>
  );
};
